// extracted by mini-css-extract-plugin
module.exports = {"gsapB":"gsapB1_gsapB__ZTh1k"};